import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import axios from "axios";
// import { LoDashStatic } from "lodash";
const API_URL = process.env.REACT_APP_BASE_URL;
const headers = {
  "Content-Type": "application/json",
};

export interface Organisation {
  id?: number;
  packageName: string;
  districtCode: string;
  districtName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchOrganisation1 = createAsyncThunk(
  "organisation/fetchOrganisation",
  async ({
    page,
    pageSize,
    search,
    sort,
    order,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: ColumnFiltersState;
  }) => {
    try {
      console.log("fetchOrganisation1 called with:", {
        page,
        pageSize,
        search,
        filters,
      });
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No authentication token found");
      }

      const response: any = await Axios.get(`api/modulemaster/list/`, {
        params: {
          page,
          page_size: pageSize,
          search: search || undefined,
          filters: filters ? JSON.stringify(filters) : undefined,
        },
      });

      const responseData = response.data;
      console.log("API response:", responseData);

      return {
        data: responseData.results || [],
        rowCount: responseData.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchOrganisation1 error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch Organisations");
    }
  }
);


export const fetchModules = createAsyncThunk(
  "modules/fetchModules",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: ColumnFiltersState;
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize,
      };

      if (search) params.search = search;

      if (sort) {
        params.ordering = order === "desc" ? `-${sort}` : sort;
      }

        if (filters && Array.isArray(filters)) {
        filters.forEach((f: any) => {
          const { id, value } = f
          if (!id || value === undefined || value === '') return

          // Date-range filters: create e.g. created_at_date_from / created_at_date_to
          if ((id === 'updated_at' || id === 'created_at') && value && typeof value === 'object') {
            const dateFilter = value as { from_date?: string; to_date?: string }
            if (dateFilter.from_date) params[`${id}_date_from`] = dateFilter.from_date
            if (dateFilter.to_date) params[`${id}_date_to`] = dateFilter.to_date
            return
          }

          // If value is an object (non-date), flatten as id_key=value (e.g., status_eq=active)
          if (value && typeof value === 'object') {
            Object.entries(value).forEach(([k, v]) => {
              if (v !== undefined && v !== null && v !== '') {
                params[`${id}_${k}`] = v
              }
            })
            return
          }

          // Default scalar filter
          params[id] = value
        })
      }

      const response: any = await Axios.get(`api/modulemaster/list/`, { params });

      const responseData = response.data;
      return {
        data: responseData.data || responseData.results || [],
        rowCount: responseData.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchModules error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch Modules");
    }
  }
);

export const fetchModulesByID = createAsyncThunk(
  "modules/fetchModulesByID",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${API_URL}/modulemaster/${id}/`);
      console.log("resp to update Id : ", response);
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Modules by ID"
      );
    }
  }
);

export const updateModules = createAsyncThunk(
  "organisation/updateModules",
  async (moduleData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }
    console.log("pkgData:", moduleData);
    const response: any = await Axios.put(
      `api/modulemaster/edit/${moduleData?.id}/`,
      moduleData
    );
    console.log("updateOrganisation response:", response);
    return response;
  }
);
export const updateModuelsStatus = createAsyncThunk(
  "organisation/updateModuels",
  async (moduleData: any, { rejectWithValue }) => {
    try {
      const payload = {
        status: moduleData.status, // only field being updated
      };

      const response = await Axios.patch(
        `api/modulemaster/edit-status/${moduleData.module_id}/`,
        payload
      );

      return response.data;
    } catch (error: any) {
      console.error("Status update failed", error);
      return rejectWithValue(error?.response?.data || "Status update failed");
    }
  }
);



export const addModuels = createAsyncThunk(
  "modulemaster/bulk-create",
  async (moduleData: any, { rejectWithValue }) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }

    try {
      const response = await Axios.post(
        `api/modulemaster/create/`,
        moduleData
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add Modules");
    }
  }
);

export const deleteModules = createAsyncThunk(
  "modules/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`, { headers });
      return id;
    } catch (err: any) {
      console.error("Delete error:", err);
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchAllModulesDropdowns = createAsyncThunk(
  "modules/fetchAllModulesDropdowns",
  async () => {
    try {
      const [
        orgRes,
        // industryRes, cityRes, stateRes,pincodeRes
      ] = await Promise.all([
        Axios.get(`${API_URL}modulemaster/dropdown/app_name`, {
          headers,
        }),
      ]);

      return { appNameDropDown: orgRes?.data?.data?.app_name };
    
      // }
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
);
//Exports csv file
// Exports department CSV file
export const exportModulesCSV = createAsyncThunk(
  "modules/exportModulesCSV",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };
      // Use responseType: 'blob' to get the file as a blob
      const response = await Axios.get("modulemaster/?export=excel", {
        headers,
        responseType: "blob",
      });
      // Return the blob and filename (if any)
      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "Modules.csv",
      };
    } catch (err: any) {
      console.error("Export CSV error:", err);
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);

export const ModulesxportsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(({ id, value }: { id: string; value: any }) => {
      if (id && value !== undefined && value !== null) {
        if (typeof value === "object" && value !== null) {
          const maybeDateFilter = value as {
            from_date?: string;
            to_date?: string;
          };

          if (
            (maybeDateFilter.from_date || maybeDateFilter.to_date) &&
            (id === "created_at" || id === "updated_at")
          ) {
            if (maybeDateFilter.from_date) {
              params.append(`${id}_from`, maybeDateFilter.from_date);
            }

            if (maybeDateFilter.to_date) {
              params.append(`${id}_to`, maybeDateFilter.to_date);
            }

            return;
          }

          // Other object filters
          Object.entries(value).forEach(([key, val]) => {
            if (val !== undefined && val !== null && val !== "") {
              params.append(key, String(val));
            }
          });
        } else {
          params.append(id, value);
        }
      }
    });
  }

  const response = await Axios.get(`/modulemaster/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "Module.csv",
  };
};

